import { render, staticRenderFns } from "./priceManager.vue?vue&type=template&id=2fc75767&scoped=true"
import script from "./priceManager.vue?vue&type=script&lang=js"
export * from "./priceManager.vue?vue&type=script&lang=js"
import style0 from "./priceManager.vue?vue&type=style&index=0&id=2fc75767&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fc75767",
  null
  
)

export default component.exports